export const T = {
  en_GB: {
    title: "Title",
    titlePlaceholder: "Financial situation",
    description: "Description",
    descriptionPlaceholder: "Optional",
    include: "Include",
    includeHelp:
      "Only the parts you switch on are printed. A part with nothing captured is left out of the document.",
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    capacity: "Capacity",
    summary: "Summary metrics",
    incomeStability: "Income stability",
    expectingChanges: "Expecting changes",
  },
  nb_NO: {
    title: "Tittel",
    titlePlaceholder: "Økonomisk situasjon",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri",
    include: "Ta med",
    includeHelp:
      "Bare delene du slår på skrives ut. En del uten registrerte opplysninger utelates fra dokumentet.",
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    capacity: "Kapasitet",
    summary: "Nøkkeltall",
    incomeStability: "Inntektsstabilitet",
    expectingChanges: "Forventede endringer",
  },
} as const;
